import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {AuthenticationService} from "../../../service/authentication-service";
import {ModalService} from "../../../service/modal.service";
import {AccessService} from "../../../service/api/access.service";
import {take, tap} from "rxjs";
import {ApiResponse} from "../../../shared/model/response/ApiResponse";
import {MessageToastService} from "../../../service/message-toast.service";
import {AccountService} from "../../../service/api/account.service";
import {AccountResponse} from "../../../shared/model/response/account-response.model";

@Component({
    selector: 'app-profile',
    templateUrl: './profile.component.html',
    standalone: false
})
export class ProfileComponent implements OnInit {

  isSocialAccount: boolean = false;

  account: AccountResponse

  showEditProfileModal: boolean = false
  showPasswordChangeModal: boolean = false
  showAddPhoneNumberModal: boolean = false

  constructor(
    private authService: AuthenticationService,
    private messageService: MessageToastService,
    private accessService: AccessService,
    private accountService: AccountService,
    private modalService: ModalService,
    private router: Router
  ) {}

  ngOnInit() {

    this.isSocialAccount = this.authService.isSocialAccount()

    this.apiGetAccount()
  }

  toggleEditProfileModal() {
    this.showEditProfileModal = !this.showEditProfileModal
  }

  togglePasswordChangeModal() {
    this.showPasswordChangeModal = !this.showPasswordChangeModal
  }

  toggleAddPhoneNumberModal() {
    this.showAddPhoneNumberModal = !this.showAddPhoneNumberModal
  }

  apiGetAccount() {
    this.accountService.getAccountById(this.authService._user.value.id, {})
      .pipe(take(1)).subscribe({
      next: (response) => {
        this.account = response?.data
      }
    })
  }

  onLogout() {
    this.modalService.simpleConfirmation({
      message: "Tem certeza que deseja terminar a sessão?"
    }).then(confirmed => {
      if (!confirmed) {
        return
      }
      this.accessService.logout()
      this.router.navigateByUrl("/acesso")
    })
  }

  onTerminateAllSessions() {
    this.modalService.simpleConfirmation({
      message: "A sessão em todos os outros dispositivos será terminada, deseja continuar?"
    }).then(confirmed => {
      if (!confirmed) {
        return
      }
      this.accessService.terminateUserSessions()
        .pipe(tap({
            next: (response) => {
              this.authService.setSession(response.data?.accessToken)
              this.messageService.success(response.message)
            },
            error: (err: ApiResponse<any>) => this.messageService.error(err.message)
          }
        ))
        .subscribe()
    })
  }

  onRemovePhoneNumber() {
    this.modalService.simpleConfirmation({
      message: "Não mais será possível fazer o login e receber notificações pelo telefone. Deseja continuar?"
    }).then(confirmed => {
      if (!confirmed) {
        return
      }
      this.accountService.removePhoneNumber(this.account.id)
        .pipe(tap({
            next: (response) => {
              this.account = response.data
              this.messageService.success(response.message)
            },
            error: (err: ApiResponse<any>) => this.messageService.error(err.message)
          }
        ))
        .subscribe()
    })
  }
}
